module.exports = __webpack_public_path__ + "static/media/Avenir-Roman.9cee5697.woff2";